import { CHAIN_ID } from "@mezo/sdk"
import { Button } from "@mezo-org/mezo-clay"

import { selectIsOnEthereumChain, useDappSelector } from "#/redux-state"
import { SDK_NETWORK } from "#/shared/constants"

import { SwitchChainButton } from "../Button"

type DepositBoxHeaderButtonProps = {
  enableTokenRelock: boolean
  unlockTime: string | null
  onClick: () => void
}

export default function DepositBoxHeaderButton({
  enableTokenRelock,
  unlockTime,
  onClick,
}: DepositBoxHeaderButtonProps) {
  const hasCorrectChain = useDappSelector(selectIsOnEthereumChain)

  if (enableTokenRelock && !hasCorrectChain) {
    return (
      <SwitchChainButton
        label={unlockTime ? "extend" : "resume"}
        chainId={CHAIN_ID[SDK_NETWORK]}
      />
    )
  }

  return (
    <Button
      shape="pill"
      size="small"
      disabled={!enableTokenRelock}
      onClick={onClick}
      overrides={{ BaseButton: { style: () => ({ width: "130px" }) } }}
    >
      {unlockTime ? "Extend boost" : "Resume boost"}
    </Button>
  )
}
